import React, { useContext, useEffect, useState } from "react";
import "./index.css";
import getRequestInterface from "utilFunctions/Axios/getRequestInterface";
import { ToastContextDispatch } from "Context/CommonContext";
import { getAPIRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
// import { Spinner, Table, UncontrolledTooltip } from "reactstrap";
import { selectInterface } from "utilFunctions/shared/PerformanceSearchBar";
import {
  plannerColumnSortMap,
  USER_ROLE_ACCESS,
} from "utilFunctions/Constants/Constants";
import ViewIcon from "Assets/Icons/ViewIcon";
import TrashIcon from "Assets/Icons/TrashIcon";
// import DownArrow from "Assets/Icons/downArrow30.png";
// import UpArrow from "Assets/Icons/upArrow30.png";
// import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
// import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import TableLayoutAntd from "utilFunctions/shared/AntdSharedComponents/TableLayoutAntd";
import { Table, Popover as PopoverAntd } from "antd";
import { convertTime } from "utilFunctions/helperFunctions/convertTime";

const SORT_DESC = "DESC";

type PrimitiveType = string | symbol | number | boolean;

interface MinTableItem {
  id: PrimitiveType;
}

type TableHeaders<T extends MinTableItem> = Record<keyof T, string>;

export interface TableProps<T extends MinTableItem> {
  fetchUrl?: string;
  isEDPDepartment?: boolean;
  isTableFilterApplied?: boolean;
  headers?: TableHeaders<T>;
  selectedFile?: any;
  customRenderers?: any;
  subjects?: selectInterface[];
  stream?: selectInterface[];
  acadYears?: selectInterface[];
  classes?: selectInterface[];
  docTypes?: selectInterface[];
  refreshTable?: boolean;
  handlePDFView?: any;
  handleDeleteDocument?: any;
  filterState?: any;
  userInfo?: any;
  selectedDocType?: any;
  selectedStream?: any;
  setPagination: any;
  pagination: any;
}
export interface documentFilterInterface {
  streamId?: number | null;
  acadYearId?: number | null;
  documentTypeId?: number | null;
  classList?: number[] | null;
  phaseList?: number[] | null;
  subjectList?: number[] | null;
}
function PlannerViewTableAntd<T extends MinTableItem>(
  props: TableProps<T>
): JSX.Element {
  const {
    fetchUrl = "",
    refreshTable,
    filterState,
    isEDPDepartment,
    isTableFilterApplied,
    userInfo,
    selectedDocType,
    selectedStream,
    pagination,
    setPagination,
  } = props;
  console.log(
    refreshTable,
    filterState,
    isEDPDepartment,
    isTableFilterApplied,
    userInfo,
    selectedDocType,
    selectedStream
  );
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const [data, setData] = useState([]);
  const [sortColumn] = useState<any>(plannerColumnSortMap["uat"]);
  const [sortOrder] = useState(SORT_DESC);
  console.log("sortColumn====", sortColumn);
  const [currentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  //   const handleSort = (column: any) => {
  //     console.log(column, "columnsort");
  //     if (plannerColumnSortMap[`${column}`] === sortColumn) {
  //       sortOrder === SORT_ASC ? setSortOrder(SORT_DESC) : setSortOrder(SORT_ASC);
  //     } else {
  //       setSortColumn(plannerColumnSortMap[`${column}`]);
  //       setSortOrder(SORT_ASC);
  //     }
  //   };

  const fetchData = async (url: string) => {
    setLoading(true);
    await getAPIRequest({
      url: url,
      success: (response: any) => {
        const data = response?.data;
        setData(data.data ? data.data : []);
        setPagination({
          ...pagination,
          total: data.totalCount,
        });
        setTimeout(() => {
          setLoading(false);
        }, 300);
      },
      failure: (err: any) => {
        setData([]);
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: err?.message,
        });
        setTimeout(() => {
          setLoading(false);
        }, 300);
      },
    } as getRequestInterface);
  };
  useEffect(() => {
    const offset = (pagination.current - 1) * pagination.pageSize;
    const limit = pagination.pageSize;
    let newUrl =
      fetchUrl +
      "?sortBy=" +
      pagination.sortField +
      "&sortDir=" +
      pagination.sortOrder +
      "&offset=" +
      offset +
      "&limit=" +
      limit;
    const filters = [];
    const formValues: any = { ...filterState };
    console.log("filterState===", filterState);
    delete formValues["chipFieldName"];
    for (const key in formValues) {
      if (Object.prototype.hasOwnProperty.call(formValues, key)) {
        if (formValues[key] != null && formValues[key] != "") {
          filters.push(
            encodeURIComponent(key) + "=" + encodeURIComponent(formValues[key])
          );
        }
      }
    }
    if (Array.isArray(filters) && filters.length > 0) {
      newUrl = newUrl + "&" + filters.join("&");
    }
    if (selectedDocType != null) {
      newUrl = newUrl + "&docTypeList=" + selectedDocType.value;
      fetchData(newUrl);
    }
  }, [
    refreshTable,
    currentPage,
    selectedDocType,
    selectedStream,
    pagination.current,
    pagination.pageSize,
    pagination.sortOrder,
  ]);
  console.log(
    "currentPage====",
    refreshTable,
    sortColumn,
    sortOrder,
    currentPage
  );
  const columns: any = [
    {
      title: "Document Title",
      dataIndex: "title",
      width: 220,
      fixed: "left",
      render: (_: any, record: any) => {
        return (
          <span
            className="tableIdStyle"
            onClick={() => props.handlePDFView(record)}
          >
            {record.title}
          </span>
        );
      },
    },
    {
      title: "Academic Year",
      dataIndex: "title",
      render: (_: any, record: any) => {
        return <span>{record.ayId}</span>;
      },
    },
    {
      title: "Class",
      dataIndex: "title",
      render: (_: any, record: any) => {
        return <span>{record.cId}</span>;
      },
    },
    {
      title: "Group/Phase",
      dataIndex: "title",
      render: (_: any, record: any) => {
        return <span>{record.pId}</span>;
      },
    },
    {
      title: "Subject",
      dataIndex: "title",
      render: (_: any, record: any) => {
        return <span>{record.sjId}</span>;
      },
    },
    {
      title: "Updated at",
      dataIndex: "title",
      render: (_: any, record: any) => {
        return <span>{convertTime(record.uat, "DD-MMM-yyyy")}</span>;
      },
    },
    {
      title: "Actions",
      dataIndex: "title",
      render: (_: any, record: any) => {
        return (
          <div className="actionButtonTableStyle">
            <div
              className="actionButtonHoverEffect"
              onClick={() => props.handlePDFView(record)}
            >
              <PopoverAntd
                placement="leftTop"
                content={() => <>View planner</>}
              >
                <ViewIcon
                  id={"viewPlannertooltip"}
                  data-toggle="tooltip"
                  data-trigger="hover"
                  className="cursorHoverCSS"
                ></ViewIcon>
              </PopoverAntd>
            </div>

            {isEDPDepartment &&
            userInfo &&
            USER_ROLE_ACCESS.includes(userInfo.fexRole) ? (
              <div
                className="actionButtonHoverEffect"
                onClick={() => props.handleDeleteDocument(record)}
              >
                <PopoverAntd
                  placement="leftTop"
                  content={() => <> Delete planner</>}
                >
                  <TrashIcon
                    id={"trashPlannertooltip"}
                    data-toggle="tooltip"
                    data-trigger="hover"
                    className="cursorHoverCSS"
                  ></TrashIcon>
                </PopoverAntd>
              </div>
            ) : null}
          </div>
        );
      },
    },
  ];
  console.log("datadatadata", data);
  const handleTableChange = (paginations: any, filters: any, sorter: any) => {
    const sortField = sorter.field || pagination.sortField;
    console.log("paginationspaginations", paginations);
    let sortOrder = pagination.sortOrder;
    if (sorter.order !== undefined) {
      sortOrder = sorter.order === "descend" ? "DESC" : "ASC";
    }
    const currentPage =
      pagination.pageSize != paginations.pageSize ? 1 : paginations.current;
    setPagination({
      ...paginations,
      current: currentPage,
      sortField,
      sortOrder: sortOrder,
    });
  };
  return (
    <div className="mt-2">
      <TableLayoutAntd isLoader={loading}>
        <Table
          scroll={{ x: "max-content" }}
          bordered
          size="small"
          columns={columns}
          dataSource={data}
          pagination={pagination}
          onChange={handleTableChange}
        />
      </TableLayoutAntd>
    </div>
  );
}

export default PlannerViewTableAntd;
